export enum LightingPattern {
  STEADY = -1,
  BREATHING = 0,
  CIRCLING = 1,
  RISING = 2,
  PARTY_MODE = 3,
}
